/* Card colourway toggle. Tap a swatch and the card swaps to that sibling in
   place: name, price and link change immediately, the render crossfades.
   Port of the toggle at the bottom of the prototype's assets/site.js, reading
   the sibling's data off the swatch's data attributes instead of a WATCHES
   array. Delegated from the document so any grid on any template inherits it. */

(function () {
  function swap(card, swatch) {
    const image = card.querySelector('[data-jhs-card-image]');
    const name = card.querySelector('[data-jhs-card-name]');
    const price = card.querySelector('[data-jhs-card-price]');

    if (swatch.dataset.url) card.setAttribute('href', swatch.dataset.url);
    if (name && swatch.dataset.title) name.textContent = swatch.dataset.title;
    if (price && swatch.dataset.price) price.textContent = swatch.dataset.price;

    card.querySelectorAll('[data-jhs-sw]').forEach((el) => el.classList.toggle('is-on', el === swatch));

    const next = swatch.dataset.image;
    if (!image || !next || image.getAttribute('src') === next) return;

    image.classList.add('is-swapping');
    const preload = new Image();
    preload.src = next;

    const apply = () => {
      image.src = next;
      image.removeAttribute('srcset');
      if (swatch.dataset.alt) image.alt = swatch.dataset.alt;
      requestAnimationFrame(() =>
        requestAnimationFrame(() => image.classList.remove('is-swapping'))
      );
    };

    const startedAt = Date.now();
    const ready = () => setTimeout(apply, Math.max(0, 120 - (Date.now() - startedAt)));
    if (preload.complete) ready();
    else {
      preload.onload = ready;
      preload.onerror = ready;
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      const swatch = event.target.closest('[data-jhs-card] [data-jhs-sw]');
      if (!swatch) return;
      event.preventDefault();
      event.stopPropagation();
      if (swatch.classList.contains('is-on')) return;
      swap(swatch.closest('[data-jhs-card]'), swatch);
    },
    true
  );
})();
